import React from 'react';
import { PinInput, PinInputProps } from '@mantine/core';

export function EPinInput({ ...props }: PinInputProps) {
    return (
        <PinInput {...props} />
    )
}